import { Warehouse } from '../models/StockLine';

export default function getWarehouseOptions(intl, withDefault = true) {
  return [
    ...(withDefault
      ? [{ value: '-', label: intl.formatMessage({ id: 'stock.all' }) }]
      : []),
    {
      value: Warehouse.FACTORY,
      label: intl.formatMessage({ id: 'stock.factory' }),
    },
    {
      value: Warehouse.FOODFORJOE_MASSANES,
      label: intl.formatMessage({ id: 'stock.massanes' }),
    },
  ];
}
